import styled from 'styled-components';
import COLORS from '../../colors';

const NaturalDeliveryContainer = styled.div`
  background-color: ${COLORS.SECONDARY_CONTAINER};
  border-radius: 4px;
  box-sizing: border-box;
  padding: 4px;
  margin: 0;
`;

const StyledText = styled.p`
  font-size: 12px;
  font-weight: 700;
  color: ${COLORS.NEUTRAL_200};
`;

interface NaturalDeliveryIconProps {
  peakPercentage: number;
}

const NaturalDeliveryIcon = ({ peakPercentage }: NaturalDeliveryIconProps) => {
  return (
    <NaturalDeliveryContainer>
      <StyledText>{peakPercentage}%</StyledText>
    </NaturalDeliveryContainer>
  );
};

export default NaturalDeliveryIcon;
